export const COMERCIALOFFER_FOLDER = 17385;
export const RELEVANT_DOCUMENTATION_FOLDER = 17386;
